export const getError = state => state.shareProject.get('error')
export const getIsSubmitting = state => state.shareProject.get('isSubmitting')
